// Module
var code = "<div ref=\"smartSelectContainer\" class=\"form-select\" tabindex=\"0\"></div>";
// Exports
module.exports = code;